export default __webpack_public_path__ + "static/media/x-image.282a6b10.svg";